<template>
  <el-dialog
      :visible.sync="visible"
      title="选择外销合同"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="80%"
  >
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="合同编号：">
        <el-input v-model="dataForm.code" placeholder="" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="客户：">
        <customer
            v-model="dataForm.customerId"
            @change="reload"
            :clearable="true"
        ></customer>
      </el-form-item>
      <el-form-item label="合同状态：">
        <el-select v-model="dataForm.status" size="mini" clearable>
          <el-option
              v-for="item in [
                  {label:'全部',value:''},
                {label:'未结束',value:10},
                {label:'已结束',value:200}
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%"
        :highlight-current-row="true"
        max-height="500"
    >
      <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
      ></el-table-column>
      <el-table-column
          prop="code"
          label="合同编号"
          header-align="center"
          align="left"
      >
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="showDetailDialog(scope.row)">
            {{ scope.row.code }}
          </el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-copy-document"
              @click="copyCode(scope.row.code)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="totalAmount"
          label="总金额"
          header-align="center"
          align="center"
          width="140"
      >
        <template slot-scope="scope">
          {{ moneyFormat(scope.row.totalAmount) }}{{ scope.row.currency }}
        </template>
      </el-table-column>
      <el-table-column
          prop="customerName"
          label="客户名称"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="businessManName"
          label="业务担当"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="creatorName"
          label="创建人"
          header-align="center"
          width="100"
          align="center"
      ></el-table-column>
      <el-table-column
          label="状态"
          header-align="center"
          align="center"
          width="80"
      >
        <template #default="{row}">
          <OrderStatusLabel :status="row.status"></OrderStatusLabel>
        </template>
      </el-table-column>
      <el-table-column
          prop="createDate"
          label="操作时间"
          header-align="center"
          width="160"
          align="center"
      >
      </el-table-column>
      <el-table-column
          :label="$t('handle')"
          header-align="center"
          align="center"
          width="80"
          fixed="right"
      >
        <template slot-scope="scope">
          <div class="flex flex-wrap justify-center">
            <el-button
                @click="sel(scope.row)"
                type="text"
                size="mini"
            >选择
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>

  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/trade/agreement/page',
        getDataListIsPage: true,
        activatedIsNeed: false
      },
      dataForm: {
        code: '',
        customerId: null,
        status: null
      }
    }
  },
  methods: {
    init () {
      this.reload()
      this.visible = true
    },
    sel (row) {
      this.$emit('change', row)
      this.close()
    },
    close () {
      this.visible = false
    }
  }
}
</script>
